import { useDispatch, useSelector } from "react-redux";
import {
  setAreCompanyQuestionsShown,
  setCurrentLevel,
  setIsInputChecked,
  setIsQuizFinished,
  setLevel,
} from "../../../redux/globalFunctions";
import { useState } from "react";
import { LoadingSpinner } from "../../loadingSpinner/LoadingSpinner";
import translations from "../../../en.json";
import translationsNo from "../../../no.json";

export function NextBtn() {
  const {
    isInputChecked,
    currentLevel,
    companyQuestions,
    isFormComplete,
    level,
    quizType,
    userData,
    language,
    cookies,
  } = useSelector((state) => state.global);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const companyForm = useSelector((state) => state.companyForm);
  const { answers } = useSelector((state) => state.answers);

  const redirectLink =
    language === "en"
      ? "https://avilo.no/en/evinity360/congratulations/"
      : "https://avilo.no/evinity360/congratulations/";

  function handleQuizFinish() {
    const data = {
      email: userData?.email,
      fullName: userData?.fullname,
      language: language,
      cookies: {
        levelTracking: cookies.levelTracking,
        ipTracking: cookies.ipTracking === null ? 0 : 1,
      },
      data: {
        quizType: quizType,
        companyForm: companyForm,
        answers: answers,
      },
    };

    setIsLoading(true);
    fetch("https://analytics.washd.id/evolve360", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok " + response.statusText);
        }
        return response.json();
      })
      .then(() => {
        dispatch(setIsQuizFinished(true));

        window.location.href = redirectLink;
      })
      .catch((error) =>
        console.error("There was a problem with the fetch operation:", error)
      )
      .finally(() => {
        setIsLoading(false);
      });
  }

  function handleClick() {
    if (currentLevel === -1 && companyQuestions === false) {
      dispatch(setCurrentLevel(currentLevel + 2));
      dispatch(setIsInputChecked(false));
    } else if (companyQuestions === true && currentLevel < 1) {
      dispatch(setCurrentLevel(currentLevel + 1));
      dispatch(setAreCompanyQuestionsShown(true));
      dispatch(setIsInputChecked(false));
    } else if (
      currentLevel === 1 &&
      ((quizType === "short" && level < 5) ||
        (quizType === "long" && level < 7))
    ) {
      dispatch(setLevel(level + 1));
      dispatch(setIsInputChecked(false));
    } else if (
      currentLevel === 1 &&
      ((quizType === "short" && level === 5) ||
        (quizType === "long" && level === 7))
    ) {
      handleQuizFinish();
    } else {
      dispatch(setIsInputChecked(false));
      dispatch(setCurrentLevel(currentLevel + 1));
    }
  }

  const btnText =
    language === "en"
      ? translations.navigateButtons
      : translationsNo.navigateButtons;

  const isBtnDisabled = !isInputChecked && !isFormComplete;

  const buttonText =
    currentLevel === 1 && quizType === "short" && level === 5
      ? btnText.submit
      : currentLevel === 1 && quizType === "long" && level === 7
      ? btnText.submit
      : btnText.next;

  return (
    <button onClick={handleClick} id="nextButton" disabled={isBtnDisabled}>
      {isLoading ? <LoadingSpinner /> : buttonText}
    </button>
  );
}
